const mySwiper_thumb = new Swiper('.swiper-thumb', {
  slidesPerView: 2.3,
  loop: true,
  spaceBetween: 5,
  grabCursor: true,
  navigation: {
    nextEl: '.swiper-button-next_thumb',
    prevEl: '.swiper-button-prev_thumb',
  },
  autoplay: {
    delay: 4000, // 4秒ごとにスライドが切り替わる
    disableOnInteraction: false, // ユーザーのインタラクション後も自動再生を継続する場合はfalseに設定
  },
  breakpoints: {
    768: {
      spaceBetween: 10,
      slidesPerView: 4,
    },
    960: {
      spaceBetween: 10,
      slidesPerView: 5,
    },
  },
});


const mySwiper_main = new Swiper('.swiper-main', {
  effect: 'fade',
  loop: true,
  fadeEffect: {
    crossFade: true,
  },
  pagination: {
    el: ".swiper-pagination", // ページネーションのクラス名を指定
    type: "fraction", // ページネーションのtypeを指定
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: {
    delay: 4000, // 4秒ごとにスライドが切り替わる
    disableOnInteraction: false, // ユーザーのインタラクション後も自動再生を継続する場合はfalseに設定
  },

  thumbs: {
    swiper: mySwiper_thumb,
  },

  breakpoints: {
    768: {
      navigation: false,
    },
    960: {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    },
  },
});


const thumb = document.querySelectorAll('.thumb-media');

const switchThumb = (index) => {
  document.querySelector('.thumb-media-active').classList.remove('thumb-media-active');
  thumb[index].classList.add('thumb-media-active');
}

const mySwiper = new Swiper('.main_slide2 .swiper', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 500,
  navigation: {
    nextEl: '.gallery02 .swiper-button-next',
    prevEl: '.gallery02 .swiper-button-prev',
  },
  on: {
    afterInit: (swiper) => {
      thumb[swiper.realIndex].classList.add('thumb-media-active');
      for (let i = 0; i < thumb.length; i++) {
        thumb[i].onclick = () => {
          swiper.slideTo(i);
        };
      }
    },
    slideChange: (swiper) => {
      switchThumb(swiper.realIndex);
    },
  }
});

window.addEventListener('scroll', function () {
  const check = window.pageYOffset;  //現在のスクロール位置を取得
  const docHeight = document.documentElement.scrollHeight;  //ページ全体の高さを取得
  const dispHeight = window.innerHeight;  //表示されている高さを取得

  if (check > docHeight - dispHeight - 200) {  //消えるときのフッターからの距離を数字で調整※サイトに合わせて変更
    $('.detail_stc').fadeOut(500);
  } else {
    $('.detail_stc').fadeIn(500);
  }
});

